import Vue from 'vue'

const TIME_KEY = 'time'
const FILE_NAME_KEY = 'file-name'
const LOCATION_KEY = 'location'
const METADATA_KEY = 'metadata'
const METADATA_MATCH_KEY = 'metadata-match-values'
const METADATA_MATCH_RANGE_KEY = 'metadata-match-range'

export const filterTypes = [{
  key: FILE_NAME_KEY,
  label: 'File Name',
  queryConfig: {
    type: 'FileName',
  },
},
{
  key: 'station-category',
  label: 'Monitoring Component',
  queryConfig: {
    type: 'CategorySpecificMatchValues',
    fieldType: 'MonitoringComponent',
  },
},
{
  key: LOCATION_KEY,
  label: 'Monitoring Location',
  queryConfig: {
    type: 'CategorySpecificMatchValues',
    fieldType: 'MonitoringLocation',
  },
},
{
  key: TIME_KEY,
  label: 'Time Created',
  queryConfig: {
    type: 'TimeRange',
  },
},
{
  key: METADATA_KEY,
  label: 'Metadata',
  queryConfig: {
    type: 'IndividualMatch',
  },
},
]

function initialState() {
  let state = {}
  filterTypes.forEach((t) => state[t.key] = [])
  state.submittedFilters = {}
  state.fileNameSearchString = ''
  return state
}
export default {
  namespaced: true,
  state: initialState,
  actions: {
    addFilter({
      commit,
    }, filter) {
      switch (filter.filterType()) {
      case FILE_NAME_KEY: {
        commit('AddFileNameFilter', filter)
        break
      }
      case 'station-category': {
        commit('AddStationCategoryFilter', filter)
        break
      }
      case LOCATION_KEY: {
        commit('AddLocationFilter', filter)
        break
      }
      case TIME_KEY: {
        commit('AddTimeFilter', filter)
        break
      }
      case METADATA_MATCH_KEY: {
        commit('AddMetadataFilter', filter)
        break
      }
      case METADATA_MATCH_RANGE_KEY: {
        commit('AddMetadataFilter', filter)
        break
      }
      default: {
        console.error(`unknown filter type ${filter}`)
      }
      }
    },
    updateFilterListByType({
      state,
    }, {
      filterType,
      filters,
    }) {
      if (filterType === 'station-category' || filterType === LOCATION_KEY) {
        state[filterType] = filters
      } else {
        console.error('cannot bulk update for filter type ', filterType)
      }
    },
    submitFilters({
      commit,
      state,
    }, options) {
      let filterViewModel = {
        MatchValuesFilters: [],
        MatchRangeFilters: [],
        TimeRangeFilters: [],
        FileNameFilters: [],
      }
      filterTypes.forEach(type => {
        let filterList = state[type.key]
        if (!type.queryConfig) {
          return
        }
        if (type.queryConfig.type == 'FileName') {
          filterViewModel.FileNameFilters.push(...filterList.map(filter => {
            return {
              FileNameFragment: filter.value,
            }
          }))
        }
        if (type.queryConfig.type == 'CategorySpecificMatchValues' && filterList.length > 0) {
          let queryObj = {}
          if (type.queryConfig.fieldName) queryObj.Field = type.queryConfig.fieldName
          queryObj.FieldType = type.queryConfig.fieldType
          queryObj.FieldValues = filterList.map(filter => filter.value)

          filterViewModel.MatchValuesFilters.push(queryObj)
        }
        if (type.queryConfig.type == 'IndividualMatch') {
          filterList.forEach(filter => {
            if (!filter) return
            if (filter.filterType().includes('values')) {
              let queryObj = {
                Field: filter.value.Field,
                FieldType: filter.value.FieldType,
                FieldValues: filter.value.FieldValues,
              }
              filterViewModel.MatchValuesFilters.push(queryObj)
            } else if (filter.filterType().includes('range')) {
              let queryObj = {
                Field: filter.value.Field,
                FieldType: filter.value.FieldType,
                MinValue: filter.value.MinValue,
                MaxValue: filter.value.MaxValue,
              }
              filterViewModel.MatchRangeFilters.push(queryObj)
            }

          })
        }
        if (type.queryConfig.type == 'TimeRange' && filterList.length > 0) {
          filterList.forEach(filter => {
            filterViewModel.TimeRangeFilters.push({
              StartDate: filter.value.start,
              EndDate: filter.value.end,
            })
          })
        }
      })
      commit('SetFilterViewModel', filterViewModel)
      if (options && options.successCb) options.successCb()
    },
    clearFilters({
      commit,
    }, options) {
      commit('ClearFilters')
      options.successCb()
    },
  },
  mutations: {
    AddFileNameFilter(state, filter) {
      if (filter.value == '') {
        Vue.set(state, FILE_NAME_KEY, [])
        return
      }
      if (!hasEqual(state[FILE_NAME_KEY], filter)) {
        Vue.set(state, FILE_NAME_KEY, [filter])
        state.fileNameSearchString = filter.value
      }
    },
    AddStationCategoryFilter(state, filter) {
      if (!hasEqual(state['station-category'], filter)) {
        pushFilter(state['station-category'], filter)
      }
    },
    AddLocationFilter(state, filter) {
      if (!hasEqual(state[LOCATION_KEY], filter)) {
        pushFilter(state[LOCATION_KEY], filter)
      }
    },
    AddTimeFilter(state, filter) {
      if (filter == null || (!filter.timeStart && !filter.timeEnd)) {
        state[TIME_KEY] = []
      } else {
        state[TIME_KEY] = [filter]
      }
    },
    AddMetadataFilter(state, filter) {
      if (!hasEqual(state[METADATA_KEY], filter)) {
        pushFilter(state[METADATA_KEY], filter)
      }
    },
    RemoveFilter(state, filterId) {
      let filterIdObj = decodeFilterId(filterId)
      state[filterIdObj.filterType] = removeFilterCopy(
        state[filterIdObj.filterType],
        filterIdObj.index
      )
    },
    ClearFilters(state) {
      filterTypes.forEach((t) => state[t.key] = [])
      Vue.set(state, 'submittedFilters', {
        MatchValuesFilters: [],
        MatchRangeFilters: [],
        TimeRangeFilters: [],
        FileNameFilters: [],
      })
      state.fileNameSearchString = ''
    },
    SetFilterViewModel(state, filterViewModel) {
      state.submittedFilters = filterViewModel
    },

  },
  getters: {
    hasFilter: state => {
      return (
        state[FILE_NAME_KEY].length +
        state['station-category'].length +
        state[LOCATION_KEY].length +
        state[TIME_KEY].length +
        state[METADATA_KEY].length
      ) > 0
    },
    allFilters: state => state,
    getFilter: state => (type) => {
      return state[type]
    },
    getFilterId: () => (filterType, index) => encodeFilterId(filterType, index),
    getSubmittedFilters: state => state.submittedFilters,
    fileNameSearchString: state => {
      return state.fileNameSearchString
    },
  },
}
const filterIdDelimiter = '::'

function encodeFilterId(filterType, index) {
  return [filterType, index].join(filterIdDelimiter)
}

function decodeFilterId(filterId) {
  let words = filterId.split(filterIdDelimiter)
  if (words.length != 2) {
    return {}
  }
  return {
    filterType: words[0],
    index: words[1],
  }
}

function hasEqual(filterList, filter) {
  let equals = filterList.filter(f => filter.equals(f))
  return equals.length > 0
}

function pushFilter(list, filter) {
  Vue.set(list, list.length, filter)
}

function removeFilterCopy(list, index) {
  if (index == 0) {
    return list.slice(1, list.length)
  }
  if (index == list.length - 1) {
    return list.slice(0, -1)
  }
  return [].concat(list.slice(0, index - 1), list.slice(index, list.length))

}